/* eslint-disable @typescript-eslint/consistent-type-definitions -- Zero mutator/query arg types must be `type` aliases to satisfy the ReadonlyJSONValue constraint; interfaces lack an implicit index signature. */
import { defineMutator } from "@rocicorp/zero"

import type { MutatorTx } from "../schema"

export type CreateWidgetContactAvatarArgs = {
	id: string
	widgetSettingsId: string
	membershipId: string
	order: number
	overrideImageUrl?: string | null
}

export type UpdateWidgetContactAvatarArgs = {
	id: string
	order?: number
	overrideImageUrl?: string | null
}

export type DeleteWidgetContactAvatarArgs = {
	id: string
}

export const widgetContactAvatarMutators = {
	create: defineMutator(
		async ({
			tx,
			args,
		}: {
			tx: MutatorTx
			args: CreateWidgetContactAvatarArgs
		}) => {
			await tx.mutate.widgetContactAvatars.insert({
				id: args.id,
				createdAt: Date.now(),
				updatedAt: Date.now(),
				order: args.order,
				overrideImageUrl: args.overrideImageUrl ?? undefined,
				widgetSettingsId: args.widgetSettingsId,
				membershipId: args.membershipId,
			})
		},
	),
	update: defineMutator(
		async ({
			tx,
			args,
		}: {
			tx: MutatorTx
			args: UpdateWidgetContactAvatarArgs
		}) => {
			await tx.mutate.widgetContactAvatars.update({
				id: args.id,
				...(args.order !== undefined ? { order: args.order } : {}),
				...(args.overrideImageUrl !== undefined
					? { overrideImageUrl: args.overrideImageUrl ?? undefined }
					: {}),
			})
		},
	),
	delete: defineMutator(
		async ({
			tx,
			args,
		}: {
			tx: MutatorTx
			args: DeleteWidgetContactAvatarArgs
		}) => {
			await tx.mutate.widgetContactAvatars.delete({ id: args.id })
		},
	),
}
